import { useEffect } from "react";
import { useSearchParams } from "react-router";

import { DEFAULT_LOGIN_URL, windowNavigation } from "../api/client";
import { WhitePanel } from "../components/InDevelopment";
import { PanelStatus } from "../components/PanelStatus";
import { SITE_TITLE } from "../config/site";

/** What each `esito` of Loggione's callback says (docs/auth-entra.md, «The error page of the login»). */
const ACCESS_MESSAGES = {
  "nessun-ruolo":
    "Il tuo account non è abilitato a Politor. Chiedi all'amministratore di assegnarti l'accesso all'applicazione.",
  scaduto: "L'accesso è scaduto prima di essere completato. Riprova.",
  errore: "Accesso non riuscito. Riprova; se il problema continua, contatta l'amministratore.",
} as const;

type Esito = keyof typeof ACCESS_MESSAGES;

function isEsito(value: string | null): value is Esito {
  return value !== null && Object.hasOwn(ACCESS_MESSAGES, value);
}

/**
 * /accesso: where the api's callback sends the browser when a sign-in ends for
 * a reason the person can act on (/accesso?esito=<code>). It is outside the app
 * layout on purpose: no header, no /me, no redirect of its own. A person who is
 * not signed in would otherwise be sent to the login again by the 401 of /me,
 * and a refused account would loop. «Riprova ad accedere» is the only way on,
 * and the person chooses it. An unknown or missing code says the generic one.
 */
export function AccessPage() {
  const [params] = useSearchParams();
  const code = params.get("esito");
  const esito: Esito = isEsito(code) ? code : "errore";

  useEffect(() => {
    const before = document.title;
    document.title = `Accesso · ${SITE_TITLE}`;
    return () => {
      document.title = before;
    };
  }, []);

  return (
    <div className="mx-auto flex min-h-screen w-full max-w-[1354px] flex-col px-4 pt-12">
      <WhitePanel>
        <section className="flex flex-col gap-[15px]">
          <h1 className="text-xl leading-7 font-semibold text-brand">Accesso a Politor</h1>
          <PanelStatus
            role="alert"
            indent={false}
            retryLabel="Riprova ad accedere"
            onRetry={() => windowNavigation.assign(DEFAULT_LOGIN_URL)}
          >
            {ACCESS_MESSAGES[esito]}
          </PanelStatus>
        </section>
      </WhitePanel>
    </div>
  );
}
